import type { PropDefinition } from 'src/components/props-table';
import { AccessTokenDescription, WidgetSessionScope } from './components';
export const scopes: WidgetSessionScope[] = [];
export const props: PropDefinition[] = [{
  name: 'authToken',
  typeSimple: 'AuthToken',
  type: 'string | (() => Promise<string>)',
  required: true,
  description: <AccessTokenDescription scopes={scopes} />
}, {
  name: 'switchToOrganization',
  typeSimple: 'function',
  type: '(args: { organizationId: string }) => void',
  required: true,
  description: 'Called when the user selects an organization from the dropdown. This function can be provided by one of our SDKs or implemented using the WorkOS API.'
}, {
  name: 'organizationLabel',
  typeSimple: 'string | null',
  description: 'The label that appears above the list of organizations.',
  default: '"Organizations"'
}];